if (!customElements.get('sticky-atc')) {
	class StickyAtc extends HTMLElement {
		constructor() {
			super();
			this.stickyHeader = document.querySelector('#SiteHeader');
			this.headerOffset = this.stickyHeader ? this.stickyHeader.offsetHeight : 0;
			this.footer = document.querySelector('.site-footer');
			this.footer?.classList.add('footer--sticky-atc-enabled');
		}

		connectedCallback() {
			this.createParentObserver();
			this.createFooterObserver();
		}

		disconnectedCallback() {
			this.parentObserver.disconnect();
			this.footerObserver.disconnect();
		}

		createParentObserver() {
			const observerOptions = {
				rootMargin: this.headerOffset > 0 ? `-${this.headerOffset}px 0px` : '0px',
			};
			this.parentObserver = new IntersectionObserver((entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						requestAnimationFrame(this.hide.bind(this));
					} else {
						requestAnimationFrame(this.reveal.bind(this));
					}
				});
			}, observerOptions);

			this.parentObserver.observe(this.parentElement);
		}

		createFooterObserver() {
			const observerOptions = {
				rootMargin: '0px',
				threshold: 0.1,
			};

			this.footerObserver = new IntersectionObserver((entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting || window.scrollY == 0) {
						requestAnimationFrame(this.hide.bind(this));
					} else {
						requestAnimationFrame(this.reveal.bind(this));
					}
				});
			}, observerOptions);

			if (this.footer) {
				this.footerObserver.observe(this.footer);
			}
		}

		hide() {
			this.classList.remove('sticky');
		}

		reveal() {
			this.classList.add('sticky');
		}
	}

	customElements.define('sticky-atc', StickyAtc);
}